/**
 * useLiveListeners — polls /api/stations/live and returns a live listener
 * count per station slug. Refreshes every N seconds.
 *
 * Usage:
 *   const { counts, total } = useLiveListeners();
 *   counts['kioo']  // number of active listeners on Kioo right now
 */

import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_MS = 15_000;

export const useLiveListeners = () => {
  const [state, setState] = useState({ counts: {}, total: 0 });

  useEffect(() => {
    let alive = true;
    const fetchOnce = async () => {
      try {
        const { data } = await axios.get(`${BACKEND_URL}/api/stations/live`);
        if (alive && data?.counts) {
          setState({ counts: data.counts, total: data.total || 0 });
        }
      } catch (_e) {
        /* silent — keep previous state */
      }
    };
    fetchOnce();
    const id = setInterval(fetchOnce, POLL_MS);
    // Also refresh when the tab becomes visible again
    const onVis = () => {
      if (document.visibilityState === 'visible') fetchOnce();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      alive = false;
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);

  return state;
};
